module.exports = __webpack_public_path__ + "img/use_activate_card_bg.ba8e678b.png";